import { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Skeleton } from '@/components/ui/skeleton';
import { Settings } from 'lucide-react';
import { useAuth } from '@/auth/hooks/useAuth';
import { useBusinesses } from '../hooks';
import { BusinessCard } from '../components';
import { ArcheHeader } from '../../../components/ArcheHeader';

export function BusinessListPage() {
  const { user } = useAuth();
  const isAdmin = useMemo(() => user?.roles?.includes('admin') ?? false, [user?.roles]);
  const { businesses, loading, error } = useBusinesses();

  return (
    <div className="flex flex-col h-full">
      <ArcheHeader archeId="arche_businesses" title="My Businesses">
        {isAdmin && (
          <Link to="/a/arche_businesses/admin">
            <Button variant="outline" size="sm">
              <Settings className="h-4 w-4 mr-2" />
              Admin
            </Button>
          </Link>
        )}
      </ArcheHeader>
      <div className="max-w-4xl mx-auto p-6 space-y-6 w-full">
        {error && <div className="text-destructive text-sm">{error}</div>}

        {loading && businesses.length === 0 ? (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {Array.from({ length: 4 }).map((_, i) => (
              <Skeleton key={i} className="h-32 rounded-lg" />
            ))}
          </div>
        ) : businesses.length === 0 ? (
          <div className="text-center py-12">
            <p className="text-muted-foreground">You don't have any businesses yet.</p>
            <p className="text-muted-foreground text-sm mt-1">
              Businesses are created through the LitCraft game client.
            </p>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {businesses.map((business) => (
              <BusinessCard key={business.businessId} business={business} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
